<app-abstract-dialog [dialogWidth]="'600'">
    <ng-container abstract-header>
        <h3 class="abstract-dialog__header__title">{{title}}</h3>
    </ng-container>
    <ng-container abstract-content>
        <div class="create-user-dialog__content">
            <app-user-info
                           [emailExists]="emailExists"
                           [selectedRoles]="selectedRoles"
                           (validateFormEvent)="validateForm($event)"
                           (createUserEvent)="createUser($event)"
                           (resetEmailExistValidationEvent)="resetEmailExistValidationEvent.emit()"
                           (roleChangeEvent)="toggleRole($event)">
            </app-user-info>
        </div>
    </ng-container>
    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'btn small outlined outlined__gray-07'"
                        (buttonClicked)="closeDialogEvent.emit()">
                    {{'GENERAL.CANCEL' | translate}}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'btn small solid__blue-07'"
                        [disabled]="createButtonDisabled"
                        (buttonClicked)="submit()">
                    {{'GENERAL.CREATE' | translate}}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
